import React from 'react';
import styled from 'styled-components';
import { CheckboxProps } from 'semantic-ui-react';
import Radio from '../Radio';
import PermissionElementWrapper from '../../pages/PermissionControls/PermissionElementWrapper';
import { IRadioGroupOption } from './types';

interface IProps {
  value: string;
  options: IRadioGroupOption[];
  name: string;
  onChange: (value: string) => void;
  hasPermissionCheck?: boolean;
  className?: string;
}

const Container = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
`;

export default ({
  value,
  name,
  onChange,
  options,
  className,
  hasPermissionCheck,
}: IProps) => {
  const handleChange = (_: unknown, props: CheckboxProps) => {
    if (typeof props.value === 'string') {
      onChange(props.value);
    }
  };

  return (
    <Container className={className}>
      {options.map((option) => (
        <PermissionElementWrapper
          key={option.value}
          /* case 1: has permission, check disabled. case 2: no permission check, render child directly */
          isPermitted={
            (!option?.disabled && !!hasPermissionCheck) || !hasPermissionCheck
          }
        >
          <Radio
            key={option.value}
            name={name}
            type="radio"
            value={option.value}
            onChange={handleChange}
            checked={option.value === value}
            disabled={option?.disabled}
            label={option.label}
          />
        </PermissionElementWrapper>
      ))}
    </Container>
  );
};
